module.exports = __webpack_public_path__ + "img/portrait-2-thumbnail.448bf58a.jpg";